<template>
  <div id="foots" class="foots">
    <div class="container">
      <!-- <div class="footer-info">
        <span><i class="el-icon-coordinate"></i> 工作时间：{{basicInfo.workingHours}}</span>
        <span><i class="el-icon-message"></i> E-mail:{{basicInfo.eMail}}</span>
        <span><i class="el-icon-mobile"></i> 联系电话：{{basicInfo.companyTel}}</span>
      </div> -->
      <div class="footer-bottom" @click="toLink">
        {{basicInfo.archiveInformation}}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
export default {
  name: "foots",
  data() {
    return {

    };
  },
  methods: {
    toLink(){
      window.open('http://beian.miit.gov.cn')
    },
    handleCommand(command) {
      console.log("click on item " + command);
    },
    //基本信息
    getInfo(){
      axios.get(`/mobile/cmWebBasicConfig/getCmWebBasicConfigById.jhtml`).then((res) => {
        this.loading = false;
        if (res.data.success) {
          this.basicInfo = res.data.output
        } else {
          this.$message('系统繁忙，请稍后再试~');
        }
      })
    },

  },
  computed: {
    basicInfo(){
      return this.$store.state.webInfo
    }
  },
  mounted(){
    //this.getInfo();
  },
};
</script>

<style scoped>
.foots {
  width: 100%;
  background: #ecf0f1;
  padding: 10px 0;
  color: #666;
  line-height: 28px;
  font-size: 12px;
}

.footer-bottom{
  text-align: center;
  cursor: pointer;
}
.footer-info{

}
.footer-info span{
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/foots.vue